import SectionCard from '../shared/SectionCard'
import { Stack } from './styled-components'
import PodUpdaterForm from '@/containers/DevToolsNew/PodUpdater/PodUpdaterForm'

const PodUpdaterPage = () => {
  return (
    <Stack>
      <SectionCard>
        <PodUpdaterForm />
      </SectionCard>
    </Stack>
  )
}

export default PodUpdaterPage
